// LatestBlogs.js
import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebook, faInstagram, faTiktok, faYoutube } from '@fortawesome/free-brands-svg-icons';
import DigitalMarketingInfo from './DigitalMarketingInfo';
import BlogList from './BlogList';
import BlogPostEditor from '../../Blog/BlogPostEditor';
import SignUpForm from '../SignUpForm'; // Import the SignUpForm component
import { api } from '../../../api';
import gr1 from '../../../assets/blog/b1 Square copy.png';
import gr2 from '../../../assets/blog/B2 Square copy.png';
import gr3 from '../../../assets/blog/B3 Square copy.png';
import gr4 from '../../../assets/blog/b6 Square copy.png';
import gr5 from '../../../assets/blog/b5 Square copy.png';
import thumbnail4 from '../../../assets/blog/b4 Square copy.png';

const items = [
    {
        imgSrc: gr1,
        title: 'Learn from My Mistakes: 7 Digital Course Pitfalls to Skip',
        description: 'Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield. Skip com...',
        subt: "Amy Porterfield",
        subtdisc: "Amy Porterfield"
    },
    {
        imgSrc: gr2,
        title: 'Learn from My Mistakes: 7 Digital Course Pitfalls to Skip',
        description: 'Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield. Skip com....',
        subt: "Amy Porterfield",
        subtdisc: "Amy Porterfield"
    },
    {
        imgSrc: gr3,
        title: 'Learn from My Mistakes: 7 Digital Course Pitfalls to Skip',
        description: 'Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield. Skip com...',
        subt: "Amy Porterfield",
        subtdisc: "Amy Porterfield"
    },
    {
        imgSrc: gr4,
        title: 'Learn from My Mistakes: 7 Digital Course Pitfalls to Skip',
        description: 'Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield. Skip com...',
        subt: "Amy Porterfield",
        subtdisc: "Amy Porterfield"
    },
    {
        imgSrc: gr5,
        title: 'Learn from My Mistakes: 7 Digital Course Pitfalls to Skip',
        description: 'Discover the top digital course pitfalls to avoid from experienced creator Amy Porterfield. Skip com...',
        subt: "Amy Porterfield",
        subtdisc: "Amy Porterfield"
    }
];

const LatestBlogs = () => {
    const [showEditor, setShowEditor] = useState(false);
    const toggleEditor = () => {
        setShowEditor((prev) => !prev);
    };

    const [isModalOpen, setIsModalOpen] = useState(false);
    const closeModal = () => setIsModalOpen(false);

    const [posts, setPosts] = useState([]);
    const [loading, setLoading] = useState(true);
    const [showSignUp, setShowSignUp] = useState(false); // State for showing the sign-up form

    const fetchPosts = async () => {
        try {
            const response = await api.get('/blogs/GetAllBlogs');
            setPosts(response.data.blogs);
        } catch (error) {
            console.error('Error fetching posts:', error);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchPosts();
    }, []);

    const handleSubscribeClick = () => {
        setShowSignUp(true); // Show the sign-up form when the button is clicked
    };

    return (
        <div className='flex flex-col md:flex-row mt-24 md:ml-12 md:mr-12'>
            <div className='flex flex-col w-full md:w-full md:ml-12 md:mr-12'>
                <div className="p-4">
                    <BlogPostEditor isOpen={isModalOpen} onClose={closeModal} onPostSuccess={fetchPosts} />
                </div>

                <div className="flex justify-between items-center mb-4">
                    <h1 className="text-4xl font-extrabold text-gray-800">Latest Blogs</h1>
                    </div>

                {loading ? (
                    <div className="text-center text-xl font-bold mt-8">Loading posts...</div>
                ) : (
                    <div className="mb-4">
                        <div className='bg-[#FD5F20] text-center text-3xl font-bold text-gray-200 rounded-lg'>
                            <img src={thumbnail4} className="w-full h-38 object-cover" />
                        </div>
                        <BlogList posts={posts} loading={loading} />
                    </div>
                )}

                {/* <div className='flex justify-center my-4'>
                    <button
                        onClick={handleSubscribeClick}
                        className="bg-[#FD5F20] text-white px-4 py-2 rounded hover:bg-[#E3551A] transition"
                    >
                        Subscribe Now
                    </button>
                </div> */}

              

                <main className="max-w-full py-4 mx-auto">
                    <DigitalMarketingInfo />
                    <div className='flex flex-col items-center justify-center'>
                        <h1 className='text-center mb-4 font-extrabold text-2xl'>Don't forget to share this post!</h1>
                        <span className='flex space-x-4'>
                            <FontAwesomeIcon icon={faFacebook} className="text-xl text-blue-600 cursor-pointer hover:text-blue-400" />
                            <FontAwesomeIcon icon={faInstagram} className="text-xl text-pink-600 cursor-pointer hover:text-pink-400" />
                            <FontAwesomeIcon icon={faTiktok} className="text-xl cursor-pointer hover:text-black" />
                            <FontAwesomeIcon icon={faYoutube} className="text-xl text-red-600 cursor-pointer hover:text-red-400" />
                        </span>
                    </div>
                    <div className="flex items-center justify-center space-x-4 my-2">
                        <hr className="flex-grow border-t border-gray-500" />
                        <span className="text-center font-bold text-lg">Recommended For You</span>
                        <hr className="flex-grow border-t border-gray-500" />
                    </div>

                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 m-2 gap-2 ">
                        {items.map((item, index) => (
                            <div key={index} className=" rounded-lg  overflow-hidden">
                               <img 
  src={item.imgSrc} 
  alt={item.title} 
  className="w-full h-auto md:h-38 object-cover"
/>
                                <div className="px-4 py-2">
                                    <p className="text-sm text-gray-600">{item.description}</p>
                                    <h4 className='text-lg font-semi-bold'>{item.subt}</h4>
                                    <p className='text-sm text-gray-600'>{item.subtdisc}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </main>
            </div>
        </div>
    );
};

export default LatestBlogs;